/** @jsxImportSource @emotion/react */

import Box from "@mui/material/Box";
import { BonusXLogo } from "../../../components/blocks/BonusXLogo";
import useIsMobile from "../../../hooks/device/useIsMobile";
import { size } from "../../../R";
import type { HeaderStoreInterface } from "../../stores/header";

interface HeaderBonusxLogoComponentInterface {
  showLogo?: boolean;
  closeButton?: HeaderStoreInterface["closeButton"];
  children: React.ReactNode;
}

export function HeaderBonusxLogo({ closeButton, showLogo, children }: Readonly<HeaderBonusxLogoComponentInterface>) {
  const isMobile = useIsMobile();
  return (
    <Box css={{ padding: size.padding.medium }}>
      {((isMobile && !closeButton) || showLogo) && <BonusXLogo />}
      {children}
    </Box>
  );
}
